import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Gift, Trash2, Plus } from "lucide-react";
import { toast } from "sonner";

export default function GiftsAdmin() {
  const [gifts, setGifts] = useState([]);
  const [form, setForm] = useState({ name: "", icon: "Gift", trust_boost: 5 });

  const load = useCallback(() => { api.get("/admin/gifts").then(({ data }) => setGifts(data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const create = async () => {
    if (!form.name.trim()) { toast.error("Gift name required"); return; }
    await api.post("/admin/gifts", { ...form, trust_boost: Number(form.trust_boost) });
    setForm({ name: "", icon: "Gift", trust_boost: 5 });
    load();
    toast.success("Gift added");
  };
  const remove = async (id) => { await api.delete(`/admin/gifts/${id}`); load(); };

  return (
    <div className="bg-surface border border-white/10 rounded-3xl p-6" data-testid="gifts-admin">
      <h2 className="font-heading text-xl font-bold mb-5 flex items-center gap-2"><Gift className="w-5 h-5 text-brand" /> Gift Inventory</h2>
      <div className="flex flex-col sm:flex-row gap-3 mb-5">
        <Input data-testid="gift-name-input" placeholder="Gift name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-12 bg-ink border-white/10 rounded-xl" />
        <Input data-testid="gift-icon-input" placeholder="Icon (Flower/Coffee/Heart/Gem/Gift)" value={form.icon} onChange={(e) => setForm({ ...form, icon: e.target.value })} className="h-12 bg-ink border-white/10 rounded-xl" />
        <Input data-testid="gift-boost-input" type="number" placeholder="Trust boost" value={form.trust_boost} onChange={(e) => setForm({ ...form, trust_boost: e.target.value })} className="h-12 bg-ink border-white/10 rounded-xl sm:w-32" />
        <Button data-testid="gift-add-button" onClick={create} className="h-12 px-5 rounded-xl bg-brand hover:bg-brand-hover text-white transition-colors"><Plus className="w-4 h-4 mr-1" /> Add</Button>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {gifts.map((g) => (
          <div key={g.id} data-testid={`admin-gift-${g.id}`} className="relative p-4 rounded-2xl border border-white/10 bg-ink text-center group">
            <p className="font-medium text-sm">{g.name}</p>
            <p className="text-[10px] text-muted-foreground mt-1">{g.icon} · +{g.trust_boost}</p>
            <button data-testid={`delete-gift-${g.id}`} onClick={() => remove(g.id)} className="absolute top-2 right-2 w-6 h-6 rounded-full bg-destructive flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"><Trash2 className="w-3 h-3 text-white" /></button>
          </div>
        ))}
      </div>
    </div>
  );
}
